// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"_id_dropdown_3G6yE","avatar":"_id_avatar_1h3gM"};